import React, { memo } from 'react';

import * as S from './style';

const LoaderSpinner = () => (
  <S.LoaderSpinner>
    <div className="ispinner">
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
      <div className="ispinner-blade" />
    </div>
  </S.LoaderSpinner>
);

export default memo(LoaderSpinner);
